import {
  Video169Code,
  Video219Code,
  Video43Code,
  Video11Code,
} from './codeHighlights/VideoCode';

const Videos: React.FC = () => {
  return (
    <>
      <h2>Aspect ratios</h2>

      <div className="row">
        <div className="col-12">
          <h2>16:9</h2>
        </div>
        <div className="col-12 col-md-6">
          <div className="ratio ratio-16x9 mb-3">
            <iframe
              src="https://www.youtube.com/embed/HVpIwFu6lIc?si=fjSFfn8pQE_T8s38"
              title="YouTube video"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Video169Code />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h2>21:9</h2>
        </div>
        <div className="col-12 col-md-6">
          <div className="ratio ratio-21x9">
            <iframe
              src="https://www.youtube.com/embed/itD4UegFI5s?si=WzkfbCw0fd7zNBZ7"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Video219Code />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h2>4:3</h2>
        </div>
        <div className="col-12 col-md-6">
          <div className="ratio ratio-4x3">
            <iframe
              src="https://www.youtube.com/embed/7zo9i90BnrQ?si=1JR0ooBFlNdVIdFy"
              title="YouTube video"
              allowFullScreen={true}
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Video43Code />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h2>1:1</h2>
        </div>
        <div className="col-12 col-md-6">
          <div className="ratio ratio-1x1">
            <iframe
              src="https://www.youtube.com/embed/PlVMIsSfEN0?si=ZtVhe2YTVxDf_PP1"
              title="YouTube video"
              allowFullScreen={true}
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Video11Code />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h2 className="mt-5">Responsive video - 16:9</h2>
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/e_exXyvVSqo"
              title="YouTube video"
              allowFullScreen={true}
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Videos;
